<template>
    <div class="hrm_input">
        <label class="hrm_input_label text-sm font-medium text-gray-800 dark:text-gray-400">
            {{ trans('lang.labels.projects') }}
        </label>
        <div class="relative mt-2">
            <VueMultiselect class="hrm-vuemultiselect hrm_input_field" v-model="filterData[filterItem.projectModels]"
                :options="filterItem?.projectOptions" @select="onChangeProject" @clear="onClearProject"
                :placeholder="trans('lang.labels.Select')" :label="filterItem.projectItemLabel"
                :valueProp="filterItem.projectItemValue" :searchable="true" />
        </div>
    </div>
    <div class="theme-input hrm_input">
        <label class="hrm_input_label text-sm font-medium text-gray-800 dark:text-gray-400">
            {{ trans('lang.labels.tasks') }}
        </label>
        <div class="relative mt-2">
            <VueMultiselect :key="componentKey" class="hrm-vuemultiselect" v-model="filterData[filterItem.taskModels]"
                :options="filterItem?.tasksOptions" :placeholder="trans('lang.labels.Select')"
                :label="filterItem?.tasksItemLabel" :valueProp="filterItem?.tasksItemValue" :searchable="true" />
        </div>
    </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import VueMultiselect from "@vueform/multiselect";

const props = defineProps({
    filterItem: { type: Object },
    filterData: { type: Object, required: true },
    errors: { type: Object },
});

const queryData = ref({
    perPage: "all",
    status: 1,
});
const componentKey = ref(1);

const onChangeProject = async () => {
    getTasks(props.filterData[props.filterItem?.projectModels]);
};

const onClearProject = () => {
    props.filterData[props.filterItem?.taskModels] = null;
    props.filterItem.tasksOptions = []
    componentKey.value += 1;
};

const getProjects = async () => {
    try {
        const response = await axios.get(route("project-management.projects.index"), {
            params: queryData.value,
        });
        props.filterItem.projectOptions = response.data.data;
    } catch (error) {
        console.error("Error fetching projects:", error);
    }
};

const getTasks = async (pId) => {
    try {
        const project = props.filterItem?.projectOptions?.find((p) => p.id === pId);
        const query = {
           perPage: "all",
           project_id: pId
        }
        const response = await axios.get(route("project-management.tasks.index", { uuid: project?.uuid }), {
            params: query,
        });
        props.filterItem.tasksOptions = response.data.data;
    } catch (error) {
        console.error("Error fetching tasks:", error);
    }
};

onMounted(async () => {
    await getProjects();
});
</script>